import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import img_OutService from './img/outService.png'


import Swal from 'sweetalert2';

function ModalVendingPause({ showModalVendingPause, setShowModalVendingPause }) {



    return (
        <>
            <Modal
                show={showModalVendingPause}
                fullscreen
                centered
            >
                <Modal.Body>
                    {/* <div className='d-flex alight-item-center justify-content-center'>
                        <section className='mx-2'>
                            <div className='d-flex justify-content-center m-0'>
                                <img className='w-50 h-100' src={img_OutService} alt='Help Img' />
                            </div>

                            <div>
                                <div className='vendindg-title'>
                                    <h2 className='text-center text-title-help fw-bold'>
                                    Lo sentimos, esta Máquina esta fuera de servicio</h2>
                                </div>
                                <div>
                                    <div className='m-4 vendindg-message alert alert-light'>
                                        <h3 className='text-center'>Pronto volvera al trabajo.</h3>
                                    </div>


                                 
                                </div>
                            </div>
                        </section>
                    </div> */}

                    <div className="vmo-root">

                        {/* Halo de fondo con pulso lento */}
                        <div className="vmo-halo" />

                        {/* ========== HEADER ========== */}
                        <header className="vmo-header">
                            <div className="vmo-badge">
                                <span className="vmo-badge-dot" />
                                <span>Estado del servicio</span>
                            </div>
                        </header>

                        {/* ========== CENTRO ========== */}
                        <main className="vmo-main">

                            {/* Imagen original enmarcada */}
                            <div className="vmo-image-frame">
                                <div className="vmo-image-ring" />
                                <div className="vmo-image-ring vmo-image-ring-2" />
                                {/* <img
                                    className="vmo-image"
                                    src={img_OutService}
                                    alt="Fuera de servicio"
                                /> */}
                                <i class="uil uil-exclamation-triangle vmo-icon"></i>

                            </div>

                            {/* Mensajes */}
                            <div className="vmo-messages">
                                <h1 className="vmo-title">
                                    Lo sentimos,
                                    <br />
                                    <span> esta máquina esta fuera de servicio</span>
                                </h1>
                            </div>
                        </main>

              
                    </div>
                </Modal.Body>
            </Modal>



        </>
    )
}

export default ModalVendingPause